export const copyTextFromElement = (selector: string, container?: HTMLElement): boolean => {
  const field = document.querySelector(selector);
  return copyText(field!.textContent!.toString(), container);
};

// `text` stays `any`: legacy call sites pass possibly-undefined values.
export const copyText = (text: any, container: HTMLElement = document.body): boolean => {
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    container.appendChild(textArea);
    textArea.select();
    textArea.focus();
    document.execCommand('copy');
    textArea.remove();
    window.getSelection()!.removeAllRanges();
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Copy to clipboard with new Clipboard API if available, falling back to execCommand.
 * @param {string} text Data to be written
 * @returns true if action was successful.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await window.navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return copyText(text);
  }
};
